import { useEffect, useState } from '../../common/common';
import useGetUserData from '../../secureAPI/GetUserData';
import * as XLSX from 'xlsx';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import axiosJWT from '../../secureAPI/axiosJWT';
import { showToast } from '../../Utils/toastUtils';
import Navigations from '../../common/useNavigation';

const MidDistributorRequest = (type) => {
    const { users,userPlan,Remainuser,subUser } = useGetUserData();
    const { navigateDashboard} = Navigations();
    const [isDisabled, setisDisabled] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [distributors, SetDistributors] = useState([]);
    const [distriCode, setDistriCode] = useState(null);
    const [lgShow, setLgShow] = useState(false);
    const [distributorconfirmation, setDistributorconfirmation] = useState(false);
    useEffect(() => {
        //  console.log('called useeffectsss');
          if (Array.isArray(users) && users.length > 0) {
            //   console.log('useEffect called, users:', users);
              logUserData(); 
          }
      }, [users]); 
      
        const logUserData = () => {
          if (users?.length > 0) {
            const userTypes = users[0]['UserType'];
            const usertypeArray = typeof userTypes === 'string' ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
    
            const hasOne = usertypeArray.includes(1);
            const hasTwo = usertypeArray.includes(2);
            if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo) ) {                
              }
              else
              {
                navigateDashboard('seller');
              }
              

          }
        };

    useEffect(() => {
        const GetdistributorRequest = async () => {
            StartLoading(setisLoading);
            const data = {app: 0};
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetdistributorRequest`, {data:data}, { withCredentials: true })
                .then((response) => {
                    StopLoading(setisLoading);
                    if (response.data.count > 0) {
                        SetDistributors(response.data.data);
                        // SetDistributors(Array.isArray(userData) ? userData : [userData]);
                    }
                    else {
                        StopLoading(setisLoading);
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading);
                    showToast('Somthing went wrong ! please try again ', 'error');
                });
        }
        GetdistributorRequest();
    }, []);
    const showconfirmation = () => {
        const distributor_UUID = Math.floor(Math.pow(8, 6) + Math.random() * 8 * Math.pow(8, 6));
        setDistriCode(distributor_UUID);
        setLgShow(false);
        setDistributorconfirmation(true);
    }
    const actionAccept = async (buyerID, sellerID,selectedOption) => {

        // alert(buyerID);
        // uid: name, buyer_id: buyer_id, seller_id: seller_id, headers: { Authorization: `Bearer ${token}` }
        await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/setDistributorRequest`, { buyer_id: buyerID, seller_id: sellerID, distri_code: distriCode,selectedOption, app:0 }, { withCredentials: true })
            .then((res) => {
                // console.log(res.data);
                SetDistributors(res.data.data);
            })
            .catch((err) => {
                //console.log(err);
            });
    }
    return {
        users,userPlan,Remainuser,subUser,distributors, SetDistributors, lgShow, setLgShow, showconfirmation, distriCode, setDistriCode, distributorconfirmation, setDistributorconfirmation, actionAccept,isLoading
    }
}

export default MidDistributorRequest